import { jsx as _jsx } from "react/jsx-runtime";
import styles from './TableStatistical.module.scss';
export const TableStatistical = (props) => {
    const { title } = props;
    return (_jsx("div", Object.assign({ className: styles.wrapper }, { children: _jsx("h3", { children: title }) })));
};
